import { CarTypesEnum } from '@/components/car-details-v2/car-type';
import { colors } from '@/constants';
import React, { memo } from 'react';

interface Props {
    className?: string;
    color?: string;
    opacity?: number;
}

export const CAR_TYPE_SHADOW_COLORS: Record<CarTypesEnum, string> = {
    [CarTypesEnum.CERTIFIED]: colors['primary-600'],
    [CarTypesEnum.LITE]: colors['lite-600'],
    [CarTypesEnum.Dealer]: colors['dealer-500'],
};

export const getShadowColorByCarType = (carType: CarTypesEnum): string => {
    return CAR_TYPE_SHADOW_COLORS[carType];
};

export const CarListingShadow = memo(
    ({
        className = '',
        color = CAR_TYPE_SHADOW_COLORS.CERTIFIED,
        opacity = 0.18,
    }: Props) => {
        return (
            <svg
                width="100%"
                height="88"
                viewBox="0 0 343 88"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className={className}
                preserveAspectRatio="none"
                style={{
                    transform: 'translateZ(0)',
                    willChange: 'transform',
                }}
            >
                <path
                    d="M0 12C0 5.37258 5.37258 0 12 0H331C337.627 0 343 5.37258 343 12V88H0V12Z"
                    fill="white"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M84.3688 72C55.9639 71.5871 27.8277 70.4881 0 68.7282V26H343V56.4189C275.937 65.6419 206.568 70.9672 135.519 72H84.3688Z"
                    fill={`url(#paint0_radial_${color.replace('#', '')})`}
                />
                <defs>
                    <radialGradient
                        id={`paint0_radial_${color.replace('#', '')}`}
                        cx="0"
                        cy="0"
                        r="1"
                        gradientUnits="userSpaceOnUse"
                        gradientTransform="translate(171.5 72.1703) rotate(90) scale(47.7392 355.968)"
                    >
                        <stop stopColor={color} stopOpacity={opacity} />
                        <stop
                            offset="0.9635"
                            stopColor="#D9D9D9"
                            stopOpacity="0.0364997"
                        />
                        <stop offset="1" stopColor="#D9D9D9" stopOpacity="0" />
                    </radialGradient>
                </defs>
            </svg>
        );
    },
    (prevProps, nextProps) => {
        return (
            prevProps.color === nextProps.color &&
            prevProps.opacity === nextProps.opacity &&
            prevProps.className === nextProps.className
        );
    }
);

CarListingShadow.displayName = 'CarListingShadow';

export default CarListingShadow;
